<template>
  <div class="p-pegas">
    <div
      class="card-table"
      :class="mode ? 'card__tableday' : 'card__tablenight'"
    >
      <div class="card-table-body ifon-add-title-block">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="caz-blocks-sarcho-title">
              <div
                class="content-title d-flex align-center mr-2"
                :class="mode ? 'content__titleday' : 'content__titlenight'"
              >
                {{ $t("message.device") }}
              </div>
              <div class="block-sarche">
                <div class="header__search">
                  <crm-input
                    :size="'small'"
                    :className="'w100'"
                    :class="mode ? 'input__day' : 'input__night'"
                    v-model="filterForm.search"
                    :icon="'el-icon-search'"
                  ></crm-input>
                </div>
              </div>
            </div>
          </el-col>

          <el-col :span="12" class="flex-style text-right">
            <crm-create-and-column-settings
              :permission="$options.name"
              @c-create="drawerCreate = true"
              :class="mode ? 'button__settingsday' : 'button__settingsnight'"
              :columns="columns"
              @c-change="updateColumn"
              :v_can_create="'devices.create'"
            >
            </crm-create-and-column-settings>
          </el-col>
        </el-row>
      </div>
      <!-- end ifon-add-title-block -->

      <div class="card-table-header table-crm-smart">
        <table
          class="table-my-code table-bordered"
          :class="mode ? 'table__myday' : 'table__mynight'"
          v-loading="loadingData"
        >
          <thead>
            <tr>
              <th class="w50p" v-if="columns.id.show">
                {{ columns.id.title }}
              </th>

              <th v-if="columns.device_name.show">
                {{ columns.device_name.title }}
              </th>

              <th v-if="columns.serial_number.show">
                {{ columns.serial_number.title }}
              </th>

              <th v-if="columns.ip_address.show">
                {{ columns.ip_address.title }}
              </th>
              <th v-if="columns.port.show">
                {{ columns.port.title }}
              </th>

              <th v-if="columns.device_type_id.show">
                {{ columns.device_type_id.title }}
              </th>

              <th v-if="columns.security_location_id.show">
                {{ columns.security_location_id.title }}
              </th>

              <th v-if="columns.status_id.show">
                {{ columns.status_id.title }}
              </th>
              <th v-if="columns.status_id.show">
                {{ $t("message.attendance_type") }}
              </th>
              <th v-if="columns.created_at.show">
                {{ columns.created_at.title }}
              </th>

              <th v-if="columns.updated_at.show">
                {{ columns.updated_at.title }}
              </th>

              <th v-if="columns.settings.show">
                {{ columns.settings.title }}
              </th>
            </tr>

            <tr class="filter_sorche">
              <th v-if="columns.id.show">
                <el-input
                  clearable
                  size="mini"
                  v-model="filterForm.id"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.id.title"
                  class="id_input"
                ></el-input>
              </th>

              <th v-if="columns.device_name.show">
                <crm-input
                  :placeholder="columns.device_name.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.device_name"
                ></crm-input>
              </th>

              <th v-if="columns.serial_number.show">
                <crm-input
                  :placeholder="columns.serial_number.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.serial_number"
                ></crm-input>
              </th>

              <th v-if="columns.ip_address.show">
                <crm-input
                  :placeholder="columns.ip_address.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.ip_address"
                ></crm-input>
              </th>
              <th v-if="columns.port.show">
                <crm-input
                  :placeholder="columns.port.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.port"
                ></crm-input>
              </th>

              <th v-if="columns.device_type_id.show">
                <select-deviceType
                  :size="'medium'"
                  :placeholder="columns.device_type_id.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.device_type_id"
                >
                </select-deviceType>
              </th>
              <th v-if="columns.security_location_id.show">
                <select-security-location
                  :size="'medium'"
                  :placeholder="columns.security_location_id.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.security_location_id"
                >
                </select-security-location>
              </th>

              <th v-if="columns.status_id.show">
                <select-status
                  :size="'medium'"
                  :table_name="'devices'"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  :placeholder="columns.status_id.title"
                  v-model="filterForm.status_id"
                ></select-status>
              </th>
              <th v-if="columns.status_id.show"></th>
              <th v-if="columns.created_at.show">
                <crm-date-picker
                  :placeholder="columns.created_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.created_at"
                ></crm-date-picker>
              </th>

              <th v-if="columns.updated_at.show">
                <crm-date-picker
                  :placeholder="columns.updated_at.title"
                  :class="mode ? 'filter__day' : 'filter__night'"
                  v-model="filterForm.updated_at"
                ></crm-date-picker>
              </th>

              <th class="settinW" v-if="columns.settings.show"></th>
            </tr>
          </thead>

          <transition-group name="flip-list" tag="tbody">
            <tr v-for="device in list" :key="device.id" class="cursor-pointer">
              <td v-if="columns.id.show">
                {{ device.id }}
                <span
                  class="online_class"
                  :class="device.online_status == 1 ? 'online' : 'ofline'"
                ></span>
              </td>

              <td v-if="columns.device_name.show">
                {{ device.device_name }}
              </td>

              <td v-if="columns.serial_number.show">
                {{ device.serial_number }}
              </td>

              <td v-if="columns.ip_address.show">
                {{ device.ip_address }}
              </td>
              <td v-if="columns.port.show">
                {{ device.port }}
              </td>
              <td v-if="columns.device_type_id.show">
                {{
                  device.device_type
                    ? device.device_type.device_type_name
                    : null
                }}
              </td>
              <td v-if="columns.security_location_id.show">
                {{
                  device.security_location
                    ? device.security_location.location_name
                    : null
                }}
              </td>
              <td v-if="columns.status_id.show">
                {{ device.status ? device.status.name : null }}
              </td>
              <td v-if="columns.status_id.show">
                <b v-if="device.attendance_type == 'exit'">Для выхода</b>
                <b v-else-if="device.attendance_type == 'entrance'"
                  >Для входа</b
                >
                <b v-else>Для входа и выхода</b>
              </td>
              <td v-if="columns.created_at.show">
                {{ device.created_at }}
              </td>

              <td v-if="columns.updated_at.show">
                {{ device.updated_at }}
              </td>

              <td v-if="columns.settings.show" class="settings-td">
                <crm-settings
                  :name="$options.name"
                  :model="device"
                  :actions="actions"
                  :permissionShow="'devices.update'"
                  :permissionDestroy="'devices.destroy'"
                  @edit="edit"
                  @delete="destroy"
                ></crm-settings>
              </td>
            </tr>
          </transition-group>
        </table>
        <div class="my___pagination">
          <crm-pagination
            @c-change="updatePagination"
            :class="mode ? 'pagination__day' : 'pagination__night'"
            :pagination="pagination"
          ></crm-pagination>
        </div>
      </div>

      <div class="app-modal app-modal__full">
        <el-drawer
          :with-header="false"
          :wrapperClosable="false"
          :visible.sync="drawerCreate"
          size="70%"
          ref="drawerCreate"
          @opened="drawerOpened('drawerCreateChild')"
          @closed="drawerClosed('drawerCreateChild')"
        >
          <crm-create
            ref="drawerCreateChild"
            drawer="drawerCreate"
          ></crm-create>
        </el-drawer>

        <el-drawer
          :with-header="false"
          :wrapperClosable="false"
          :visible.sync="drawerUpdate"
          size="70%"
          ref="drawerUpdate"
          @opened="drawerOpened('drawerUpdateChild')"
          @closed="drawerClosed('drawerUpdateChild')"
        >
          <crm-update
            :selectedItem="selectedItem"
            ref="drawerUpdateChild"
            drawer="drawerUpdate"
          ></crm-update>
        </el-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import list from "@/utils/mixins/list";
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import selectDeviceType from "@/components/filters/inventory/select-deviceType";
import selectStatus from "@/components/filters/inventory/select-status";
import { i18n } from "@/utils/i18n";
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "DeviceController",
  mixins: [list],
  components: {
    CrmCreate,
    CrmUpdate,
    selectDeviceType,
    selectStatus
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      list: "device/list",
      columns: "device/columns",
      pagination: "device/pagination",
      statues: "device/statues",
      filter: "device/filter",
      sort: "device/sort",
      mode: "MODE"
    }),
    actions: function() {
      return ["edit", "delete"];
    }
  },
  methods: {
    ...mapActions({
      updateList: "device/index",
      setPagination: "device/setPagination",
      updateSort: "device/updateSort",
      updateFilter: "device/updateFilter",
      updateColumn: "device/updateColumn",
      updatePagination: "device/updatePagination",
      show: "device/show",
      empty: "device/empty",
      delete: "device/destroy",
      refreshData: "device/refreshData"
    })
  }
};
</script>

<style lang="scss" scoped>
.online_class {
  width: 10px;
  display: inline-flex;
  line-height: 18px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(186, 148, 148);
}
.ofline {
  background-color: rgb(242, 109, 109);
}
.online {
  background-color: rgb(92, 246, 45);
}
</style>
